import { word } from "@modules/core/utils/i18n"
import { MediaDetailsImage } from "@modules/sessionBlock/media/components/mediaDetailsImage"
import { MediaDetailsPdf } from "@modules/sessionBlock/media/components/mediaDetailsPdf"
import { MediaDetailsVideo } from "@modules/sessionBlock/media/components/mediaDetailsVideo"
import { Media, MediaType } from "@modules/sessionBlock/media/mediaTypes"
import { HUText } from "@modules/ui/components/huText"
import { ThemeMode } from "@modules/ui/styles/theme"
import { YouTubeVideo } from "@modules/utils/components/youTubeVideo"
import { convertYoutubeLinkToEmbed, isYoutubeLink } from "@modules/utils/convertYoutubeLink"
import { useTheme } from "styled-components"

type Props = {
  medias: Media[]
} & React.HTMLAttributes<HTMLDivElement>

export const MediaDetails: React.FC<Props> = ({ medias, ...props }) => {
  const theme = useTheme()

  return (
    <div
      className={
        "flex flex-column p-3 gap-3 rounded-big-radius border-1 border-neutralColor-200 " +
        (theme.mode === ThemeMode.OWNER ? "bg-neutralColor-50" : "")
      }
      {...props}
    >
      <HUText fontStyle="TS" color={theme.neutralColor700}>
        {word("sessionForm.blocks.media")}
      </HUText>

      {medias.map((media, index) => (
        <div
          key={index}
          className="border-1 rounded-33 border-neutralColor-300 flex flex-column overflow-hidden"
          style={{ height: 320 }}
        >
          {media.type === MediaType.S3_VIDEO ? (
            <MediaDetailsVideo key={index} media={media} />
          ) : media.type === MediaType.S3_IMAGE ? (
            <MediaDetailsImage key={index} media={media} />
          ) : media.type === MediaType.S3_PDF ? (
            <MediaDetailsPdf key={index} media={media} />
          ) : media.type === MediaType.YOUTUBE && media.url && isYoutubeLink(media.url) ? (
            <YouTubeVideo
              key={index}
              link={convertYoutubeLinkToEmbed(media.url)}
              width={492}
              height={320}
              className="max-w-max rounded-big-radius overflow-hidden m-auto"
            />
          ) : (
            <HUText fontStyle="BM" style={{ overflowWrap: "break-word" }} key={index}>
              {word("sessionForm.blocks.add_media.missing_error")}
            </HUText>
          )}
        </div>
      ))}
    </div>
  )
}
